// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 472) return "static/chunks/472-9d5bae654ebc1e68.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"e59722e889514489","651":"6b0a0a214e3e799c","679":"7b1050343737d04f","741":"a83780b663de33f6","869":"73e5c063bb68454b"}[chunkId] + ".js";
};